import {ChatAdvisorPageConfig} from '@dcp/configurator';
import {UNLEASH_TOGGLES} from './FeatureToggleConfig';

export const DCP_CHAT_ADVISOR_PAGE_CONFIG: ChatAdvisorPageConfig = {
  masterToggle: UNLEASH_TOGGLES.chatAdvisorEnabled,
  pages: {
    search: {
      patterns: [/\/search(\/|$)/],
      toggleName: UNLEASH_TOGGLES.chatAdvisorSearchEnabled,
    },
    configurator: {
      patterns: [/\/configurator(\/|$)/, /\/configure(\/|$)/, /\/configure-cpq-product(\/|$)/],
      toggleName: UNLEASH_TOGGLES.chatAdvisorConfiguratorEnabled,
    },
    checkout: {
      patterns: [/\/checkout\/data-entry(\/|$)/],
      toggleName: UNLEASH_TOGGLES.chatAdvisorCheckoutEnabled,
    },
    cart: {
      patterns: [/\/cart(\/|$)/],
      toggleName: UNLEASH_TOGGLES.chatAdvisorCartEnabled,
    },
    reviewOrder: {
      patterns: [/\/checkout\/review-order(\/|$)/],
      toggleName: UNLEASH_TOGGLES.chatAdvisorReviewOrderEnabled,
    },
    registration: {
      patterns: [
        /\/selectionType(\/|$)/,
        /\/b2[bi]-company-selection(\/|$)/,
        /\/b2[bi]-registration(\/|$)/,
        /\/customer-name(\/|$)/,
      ],
      toggleName: UNLEASH_TOGGLES.chatAdvisorRegistrationEnabled,
    },
    orderConfirmation: {
      patterns: [/\/order-confirmation(\/|$)/],
      toggleName: UNLEASH_TOGGLES.chatAdvisorOrderConfirmationEnabled,
    },
  },
};
